import { render, staticRenderFns } from "./CargoPickupForm.vue?vue&type=template&id=87d478c4&scoped=true&"
import script from "./CargoPickupForm.vue?vue&type=script&lang=js&"
export * from "./CargoPickupForm.vue?vue&type=script&lang=js&"
import style0 from "./CargoPickupForm.vue?vue&type=style&index=0&id=87d478c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d478c4",
  null
  
)

export default component.exports